
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.521 11.551l.14-.187.047-.375s1.172.14 1.172 0-1.125-.047-1.125-.047v-.093l1.64-.188.047-.656-1.546.141v-1.92l.093-.048 6.653-.28s.14-.47 0-.47-6.746-.374-6.746-.374v-.89s.28-1.734.14-2.108c-.093-.375-.234-.61-.515-.61h-.047c-.281 0-.422.235-.515.61-.094.374.14 2.108.14 2.108v.89s-6.605.328-6.746.375c-.14 0 0 .468 0 .468l6.653.281.093.047v1.921l-1.546-.14.047.655 1.64.188v.093s-1.125-.046-1.125.047 1.172 0 1.172 0l.047.375.187.187z"}})])
          )
        }
      }
    